import { useEffect, useReducer } from 'react';

export default function useLoadAppleSignIn(isOpen: boolean) {
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  useEffect(() => {
    if (!isOpen || typeof window.AppleID !== 'undefined') {
      return;
    }

    function onLoad() {
      forceUpdate();
    }

    let script: HTMLScriptElement;

    function loadAppleSignIn() {
      const src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';

      const existing = document.querySelector(`script[src="${src}"]`);

      if (!existing) {
        script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.addEventListener('load', onLoad);
        document.body.appendChild(script);
      }
    }

    loadAppleSignIn();

    return () => {
      if (script) {
        script.removeEventListener('load', onLoad);
      }
    };
  }, [isOpen]);

  return typeof window !== 'undefined' && typeof window.AppleID !== 'undefined';
}
